import axios from 'axios';
import { API_BASE_URL } from './config';

/**
 * Service für die Verwaltung von Cloud Storage Bestellungen
 */
class CloudStorageService {
  constructor() {
    this.axiosInstance = axios.create({
      baseURL: API_BASE_URL,
      withCredentials: true
    });
  }

  /**
   * Bestellt ein neues Cloud Storage Produkt
   * @param {Object} orderDetails - Details der Bestellung
   * @param {number} orderDetails.userId - ID des Benutzers
   * @param {string} orderDetails.storageSize - Größe des Speichers (z.B. '500gb', '1tb')
   * @param {string|null} orderDetails.cloudBackupServer - ID des Cloud-Backup-Servers (falls zutreffend)
   * @param {Object} orderDetails.features - Ausgewählte Features (smb, rclone, webdav)
   * @param {number} orderDetails.totalPrice - Gesamtpreis der Bestellung
   * @returns {Promise} - Promise mit dem Ergebnis der Bestellung
   */
  orderCloudStorage(orderDetails) {
    // Konvertiere die Bestelldetails in das erwartete Format
    const orderData = {
      userId: orderDetails.userId,
      serviceType: orderDetails.cloudBackupServer ? 'cloudBackup' : 'webDav',
      storageSize: orderDetails.storageSize,
      cloudBackupServer: orderDetails.cloudBackupServer,
      features: orderDetails.features,
      totalPrice: orderDetails.totalPrice
    };

    return this.axiosInstance.post('/iaas-service/cloud-storage/order', orderData);
  }

  /**
   * Holt alle Cloud-Storage-Services eines Benutzers
   * @param {number} userId - ID des Benutzers
   * @returns {Promise} - Promise mit den Diensten des Benutzers
   */
  getUserCloudServices(userId) {
    return this.axiosInstance.get('/iaas-service/cloud-storage/services', {
      params: userId ? { userId } : undefined
    });
  }

  /**
   * Holt alle aktiven Cloud-Storage-Services eines Benutzers
   * @param {number} userId - ID des Benutzers
   * @returns {Promise} - Promise mit den aktiven Diensten des Benutzers
   */
  getActiveUserCloudServices(userId) {
    return this.axiosInstance.get('/iaas-service/cloud-storage/services/active', {
      params: userId ? { userId } : undefined
    });
  }
}

export default new CloudStorageService();
